import PropTypes from 'prop-types';

const EntityAttribute = ({ label, className, value, valueClassName, valueChild, icon }) => {
    return (
        <div
            className={`grid grid-cols-2 justify-between grid-rows-[40px] leading-[26px] h-[40px] ${className ?? ''}`}
            title={value || ''}
            key={`${label}`}>
            <div className="text-sf-gray-500 text-14 text-ellipsis">{label}:</div>
            {valueChild ? (
                valueChild
            ) : (
                <div
                    className={`text-sf-white text-ellipsis text-13 w-15 whitespace-nowrap overflow-hidden ${
                        valueClassName ?? ''
                    }`}>
                    {value}
                </div>
            )}
            {icon}
        </div>
    );
};

EntityAttribute.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.any,
    className: PropTypes.string,
    valueClassName: PropTypes.string,
    valueChild: PropTypes.element,
    icon: PropTypes.element
};

export { EntityAttribute };
